<template>
  <main class="container main-location">
    <section class="wellcome-section">
      <img class="topic-icon" src="@/assets/images/location/edu/topic_icon.svg" />
      <h1>Educational Facilities</h1>
      <p>
        Please create an environment where my children can
        <br />
        emain worry-free.
      </p>
      <div class="topic-tags">
        <span class="tag"> #Kindergartens </span>
        <span class="tag"> #Schools </span>
        <span class="tag"> #Academies </span>
        <span class="tag"> #Universities </span>
        <span class="tag"> #etc </span>
      </div>
    </section>

    <img
      :src="require(`@/assets/images/location/edu/main${mobileCheck ? '_mo' : ''}.png`)"
      class="main-img"
      alt="CESCO [BusinessSectors] Educational Facilities"
    />

    <section class="location-content">
      <section class="location-content-1">
        <h3>Are these concerns <br class="mo_show" />relevant to you?</h3>
        <div class="concerns-card-list">
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_infectiousdiseases.svg" alt="CESCO [BusinessSectors] Educational Facilities" />
            <div class="title">
              <h3>Anxiety about Infectious Diseases</h3>
            </div>
            <p class="description">Offer services that reassure parents and students with effective bacteria and virus management.</p>
          </div>
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_safety.svg" alt="CESCO [BusinessSectors] Educational Facilities" />
            <div class="title">
              <h3>Safety of Pest Control Agents</h3>
            </div>
            <p class="description">Although I regularly disinfect, I don’t exactly know which chemicals are the most effective.</p>
          </div>
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_foodvirus.svg" alt="CESCO [BusinessSectors] Educational Facilities" />
            <div class="title">
              <h3>Food Poisoning Concerns</h3>
            </div>
            <p class="description">Despite managing the cooking facilities, I occasionally worry whether they are properly managed.</p>
          </div>
        </div>
      </section>

      <section class="location-content-2">
        <h3>With CESCO, <br class="mo_show" />Find Your Solution.</h3>
        <div>
          <div class="border-content">
            <h4>Do not worry about the spaces where your precious children spend most of their time.</h4>
            <p>
              We address fundamental issues related to the spread of harmful bacteria and viruses by providing tailored solutions for each space,
              creating a comfortable environment that alleviates concerns for both students and parents.
            </p>
          </div>
          <div>
            <img src="@/assets/images/location/edu/border_content_01.png" alt="CESCO [BusinessSectors] Educational Facilities" />
          </div>
          <div>
            <img src="@/assets/images/location/edu/border_content_02.png" alt="CESCO [BusinessSectors] Educational Facilities" />
          </div>
          <div class="border-content">
            <h4>We manage with the safest and most validated methods for children's safety.</h4>
            <p>
              Using insecticides less toxic than salt, employing verified equipment are steadfast commitments from CESCO to ensure children’s safety
            </p>
          </div>
        </div>
      </section>
    </section>

    <section class="location-swiper">
      <div>
        <h3>
          CESCO’s Advanced Science Ensures 24/7
          <br />
          Management of Hazardous Elements Within Spaces
        </h3>

        <span class="swiper-navigation">
          <button type="button" class="me-swiper-button-prev" :disabled="prevDisabled" @click="slidePrev">
            <img src="@/assets/images/icons/Left Circle.svg" />
          </button>
          <button type="button" class="me-swiper-button-next" :disabled="nextDisabled" @click="slideNext">
            <img src="@/assets/images/icons/Right Circle.svg" />
          </button>
        </span>
      </div>

      <swiper ref="swiperRef" :slides-per-view="'auto'" :centered-slides="true" @slideChange="onSlideChange">
        <swiper-slide v-for="(item, index) in slildeList" :key="`product-slide-${index}`">
          <img :src="item.backgroundImg" alt="CESCO [BusinessSectors] Educational Facilities" />

          <button
            v-for="(productItem, productIndex) in item.products"
            :key="`product-slide-product-${productIndex}`"
            @click="handleButtonClick(productItem.productInfo)"
            :style="`
              top: ${mobileCheck ? productItem.mobilePosY : productItem.posY};
              left: ${mobileCheck ? productItem.mobilePosX : productItem.posX};
              transform: ${mobileCheck ? 'translate(-50%, -50%)' : 'none'};`"
          >
            <img src="@/assets/images/icons/add-icon-primary.svg" />
          </button>
        </swiper-slide>

        <button class="swiper-button-prev" :disabled="prevDisabled" @click="slidePrev"></button>
        <button class="swiper-button-next" :disabled="nextDisabled" @click="slideNext"></button>
      </swiper>
    </section>

    <section class="location-footer">
      <section class="add-section">
        <h3>CESCO <br class="mo_show" />Certification Mark</h3>
        <p>
          CESCO provides promotional materials to businesses managing various hazards such as pests, viruses, and water quality. These materials help
          businesses be recognized by customers as safe and hygienic.
        </p>
        <img src="@/assets/images/location/certification_mark.png" alt="CESCO [BusinessSectors] Educational Facilities" />
      </section>

      <h3>
        Top 3 Solutions <br class="mo_show" />Most Requested by
        <br />
        Educational Facilities
      </h3>

      <div class="solution-card-list">
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_total.svg" alt="CESCO [BusinessSectors] Educational Facilities" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Integrated
                  <br />
                  Pest Control
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Pest control for cockroaches, ants, and rats</p>
            </div>
            <router-link to="/solution/service/total"> Learn More </router-link>
          </div>
        </div>
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_viruscare.svg" alt="CESCO [BusinessSectors] Educational Facilities" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Viruscare
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Manual disinfection and advanced equipment for 24-hour sterilization</p>
            </div>
            <router-link to="/solution/service/virusCare"> Learn More </router-link>
          </div>
        </div>
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_food.svg" alt="CESCO [BusinessSectors] Educational Facilities" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Food Safety
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Systematic diagnostics and solutions for food safety</p>
            </div>
            <router-link to="/solution/service/food"> Learn More </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>

  <LocationModalView :modal-state="modalState" @close-modal="closeModal" :productData="productData" />
</template>

<script setup>
import { inject, ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { useMeta } from 'vue-meta'
import { useSlide, useModal } from '@/hooks'
import LocationModalView from '@/components/common/LocationModalView.vue'

const { prevDisabled, nextDisabled, swiperRef, onSlideChange, slidePrev, slideNext } = useSlide()
const { modalState, openModal, closeModal } = useModal()

const mobileCheck = inject('mobileCheck')

const productData = ref({})

const slildeList = [
  {
    backgroundImg: require('@/assets/images/location/edu/background_img_01.png'),
    products: [
      {
        posX: '29.3125rem',
        posY: '8.12rem',
        mobilePosX: '40%',
        mobilePosY: '25%',
        productInfo: {
          image: require('@/assets/images/location/edu/product_img_01.png'),
          name: 'CESCO\nAirgenic',
          description: 'This automatic air freshener and deodorizer boasts powerful odor neutralization and fragrance release.'
        }
      },
      {
        posX: '54.25rem',
        posY: '24.1825rem',
        mobilePosX: '68%',
        mobilePosY: '67%',
        productInfo: {
          image: require('@/assets/images/location/edu/product_img_02.png'),
          name: 'CESCO\nWater Stand-type Water Purifier',
          description: 'Ideal for multi-use facilities, this purifier offers extensive water purification capacity and substantial intake space.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/edu/background_img_02.png'),
    products: [
      {
        posX: '26.625rem',
        posY: '23.4325rem',
        mobilePosX: '36%',
        mobilePosY: '73%',
        productInfo: {
          image: require('@/assets/images/location/edu/product_img_03.png'),
          name: 'CESCO\nAir IOT Air Purifier SE',
          description: 'Manage air quality intelligently with options customized for your business environment.'
        }
      },
      {
        posX: '51.9375rem',
        posY: '6.37rem',
        mobilePosX: '68%',
        mobilePosY: '22%',
        productInfo: {
          image: require('@/assets/images/location/edu/product_img_04.png'),
          name: 'CESCO\nAir Sterilizer',
          description:
            'This system can manage large multi-use spaces using the oversized Virus Pre-attack System<sup>TM</sup>.\n*Select an appropriate air sterilizer based on the spatial environment.'
        }
      },
      {
        posX: '63.0625rem',
        posY: '18.745rem',
        mobilePosX: '83%',
        mobilePosY: '53%',
        productInfo: {
          image: require('@/assets/images/location/edu/product_img_05.png'),
          name: 'CESCO\nAutomatic Hand Sanitizer Sanigenic',
          description: 'Removes more than 99.999% of harmful bacteria on hands in public places, preventing cross-contamination.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/edu/background_img_03.png'),
    products: [
      {
        posX: '49.3125rem',
        posY: '18.745rem',
        mobilePosX: '65%',
        mobilePosY: '62%',
        productInfo: {
          image: require('@/assets/images/location/edu/product_img_04.png'),
          name: 'CESCO\nAir Sterilizer',
          description:
            'This system can manage large multi-use spaces using the oversized Virus Pre-attack System<sup>TM</sup>. \n*Select an appropriate air sterilizer based on the spatial environment.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/edu/background_img_04.png'),
    products: [
      {
        posX: '33.4375rem',
        posY: '25.9325rem',
        mobilePosX: '45%',
        mobilePosY: '71%',
        productInfo: {
          image: require('@/assets/images/location/edu/product_img_06.png'),
          name: 'CESCO\nWater Smart-Fit Direct Water Purifier',
          description: 'Enhance your kitchen with a water purifier available in eight colors tailored to your personal taste.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/edu/background_img_05.png'),
    products: [
      {
        posX: '50.875rem',
        posY: '25.9325rem',
        mobilePosX: '67%',
        mobilePosY: '75%',
        productInfo: {
          image: require('@/assets/images/location/edu/product_img_07.png'),
          name: 'CESCO\nAir Radon RoomCare Air Purifier SE',
          description: 'Continuously manages harmful substances such as ultrafine dust, radon, and CO2 in living rooms and bedrooms.'
        }
      },
      {
        posX: '66.9375rem',
        posY: '7.12rem',
        mobilePosX: '88%',
        mobilePosY: '23%',
        productInfo: {
          image: require('@/assets/images/location/edu/product_img_08.png'),
          name: 'CESCO\nAirgenic',
          description: 'This automatic air freshener and deodorizer boasts powerful odor neutralization and fragrance release.'
        }
      }
    ]
  }
]

/**
 * 슬라이드 버튼 클릭
 * @param {object} item
 */
const handleButtonClick = item => {
  productData.value = item
  openModal()
}

useMeta({
  title: 'CESCO - Educational Facilities',
  meta: [
    {
      vmid: 'description',
      name: 'description',
      content: 'Educational Facilities. Please create an environment where my children can emain worry-free.'
    }
  ]
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/location.scss';
</style>
